import React, { useState, useEffect } from "react";
import axios from "axios";
import { usageService,commonService } from "../../../services/index";
import { useHistory } from "react-router-dom";
import { config } from "../../../enviroment";
import { Button } from "@material-ui/core";

async function generateCaptureContext(amount, connectionId) {
  return new Promise((resolve, reject) => {
    axios
      .post(
        config.urls.USAGE_SERVICE_URL + '/usage-service',
        {
          query: `{ generateCaptureContext(amount: ${amount}, connectionId: "${connectionId}") }`
        },
        { headers: { "Content-Type": "application/json" } }
      )
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response?.data || error));
  });
}


export default function ClickToPayComponent({
  checkedA,
  billpay,
  connectionId,
  amount,
  paymentType,
  landingResponse,
  emailId,
  mobileNo,
  accentButton
}) {
  const [loading, setLoading] = useState(false);
  const [configLoading, setConfigLoading] = useState(true);
  const landing = landingResponse || {};
  const emailLocal = landing.emailId || localStorage.getItem("email") || emailId;
  const firstName = landing.firstName || "";
  const lastName = landing.lastName || "";
  const userName = landing.customerName || "";
  const propertyCode = landing.propertyCode || "";
  const mobileLocal = localStorage.getItem("mobileNo") || mobileNo;
  const isBillPay = billpay === "true";
  const [iframeReady, setIframeReady] = useState(false);
  const [prePaymentRes, setPrePaymentRes] = useState(null);
  const history = useHistory();
  // amount = "5.00"; // hardcoded for testing in prod replace later


  useEffect(() => {
    initializePayment();
  }, []);

  useEffect(() => {
    const container = document.getElementById("buttonPaymentListContainer");
    if (!container) return;

    const mutationObserver = new MutationObserver(() => {
      const iframe = container.querySelector("iframe");
      if (iframe) {
        mutationObserver.disconnect();
        const resizeObserver = new ResizeObserver((entries) => {
          for (const entry of entries) {
            const { width, height } = entry.contentRect;
            if (width > 0 && height > 0) {
              setIframeReady(true);
              resizeObserver.disconnect();
            }
          }
        });
        resizeObserver.observe(iframe);
      }
    });

    mutationObserver.observe(container, { childList: true, subtree: true });
    return () => mutationObserver.disconnect();
  }, []);

  const decodeJWT = (token) => {
    try {
      const parts = token.split(".");
      if (parts.length !== 3) throw new Error("Invalid JWT");
      let payload = parts[1];
      payload = payload.replace(/-/g, "+").replace(/_/g, "/");
      const padded = payload + "=".repeat((4 - payload.length % 4) % 4);
      const decodedPayload = atob(padded);
      return JSON.parse(decodedPayload);
    } catch (err) {
      console.error("JWT decode error:", err);
      throw err;
    }
  };



  const initializePayment = async () => {
    setLoading(true);
    try {
      setConfigLoading(true);
      const response = await generateCaptureContext(amount, connectionId);
      const captureContextJwt = response.data.generateCaptureContext.captureContext;
      if (!captureContextJwt) throw new Error("No capture context");
      const decoded = decodeJWT(captureContextJwt);
      const scriptUrl = decoded?.ctx?.[0]?.data?.clientLibrary;
      const scriptIntegrity = decoded?.ctx?.[0]?.data?.clientLibraryIntegrity;
      const clientReferenceCode = decoded?.ctx?.[0]?.data?.clientReferenceInformation?.code;
      const script = document.createElement("script");
      script.src = scriptUrl;
      if (scriptIntegrity) script.integrity = scriptIntegrity;
      script.crossOrigin = "anonymous";
      script.async = true;
      script.onload = async () => {
        try {
          if (!window.Accept) {
            throw new Error("CyberSource Accept not available");
          }
          const acceptObj = await window.Accept(captureContextJwt);
          const uPayment = await acceptObj.unifiedPayments();
          setConfigLoading(false);
          const paymentResult = await uPayment.show({
            containers: { paymentSelection: "#buttonPaymentListContainer" },
          });
          console.log("CyberSource SDK loaded successfully");
          await handlePrePayment(clientReferenceCode);

          let completeResponse = await uPayment.complete(paymentResult);

          // completeResponse = "eyJraWQiOiIwODNhcUNPV0pUVXFsN3BPNlVHWXhYUEtHUkJrRE1sbSIsImFsZyI6IlJTMjU2In0.eyJkZXRhaWxzIjp7ImNsaWVudFJlZmVyZW5jZUluZm9ybWF0aW9uIjp7ImNvZGUiOiJPUkRFUl8xNzYxNzM1MzQ1NzM0X20zeTEifSwiY29uc3VtZXJBdXRoZW50aWNhdGlvbkluZm9ybWF0aW9uIjp7ImVjaSI6IjA1In0sIm9yZGVySW5mb3JtYXRpb24iOnsiYW1vdW50RGV0YWlscyI6eyJhdXRob3JpemVkQW1vdW50IjoiMTAuMDAiLCJjdXJyZW5jeSI6IlFBUiJ9fSwicGF5bWVudEFjY291bnRJbmZvcm1hdGlvbiI6eyJjYXJkIjp7InR5cGUiOiIwMDEifX0sInBheW1lbnRJbmZvcm1hdGlvbiI6eyJjYXJkIjp7InR5cGUiOiJWSVNBIn0sInRva2VuaXplZENhcmQiOnsidHlwZSI6IjAwMSJ9fSwicHJvY2Vzc29ySW5mb3JtYXRpb24iOnsiYXBwcm92YWxDb2RlIjoiODMxMDAwIiwibmV0d29ya1RyYW5zYWN0aW9uSWQiOiIwMTYxNTM1NzAxOTgyMDAiLCJyZXNwb25zZUNvZGUiOiIwMCIsInJlc3BvbnNlRGV0YWlscyI6IkFCQyIsInJldHJpZXZhbFJlZmVyZW5jZU51bWJlciI6IjUzMDIxMDYwMDY2OCIsInN5c3RlbVRyYWNlQXVkaXROdW1iZXIiOiI2MDA2NjgiLCJ0cmFuc2FjdGlvbklkIjoiMDE2MTUzNTcwMTk4MjAwIn0sInJlY29uY2lsaWF0aW9uSWQiOiI3NjE3MzUzOTY4Mzg2MTczMzA0NTAyIiwic3VibWl0VGltZVV0YyI6IjIwMjUtMTAtMjlUMTA6NTY6MzdaIn0sImlkIjoiNzYxNzM1Mzk2ODM4NjE3MzMwNDUwMiIsIm1lc3NhZ2UiOiJSZXF1ZXN0IHByb2Nlc3NlZCBzdWNjZXNzZnVsbHkuIiwib3V0Y29tZSI6IkFVVEhPUklaRUQiLCJzdGF0dXMiOiJBVVRIT1JJWkVEIn0.HeP3AptBzUBrUv3MZQm9eLrcrul4VSsa3ryaFvp7PPbZZsqYsgM0Cndz02tngK5HpGfQaoBq82txXagBItimShjFGr2lhVNE1rvtehZf6Ap8RH1PCnmBfqNM1veYp-U8nzFbMGdlpjwlxcnznDdu5mRUIRpj5C_lg8C-LKVL-Viq4yyUaukCylJ-inxVJgm8DAXx-9jJh5uEWo2JiPOxHfEWV6U6f3JoaVREKZGepzqmOGIOz4NY0oKBBiXVE3prccZJJJYF68Vv5Ef951M0Dg_KNyL1lQtmHAt9icJ0FNMxhw637aBZZUHzaASswhwAOgIiDOHQJ29sjv1B30v1vw";

          let decodedPaymentresponse = decodeJWT(completeResponse);
          history.push({
            pathname: isBillPay
              ? "/path/payment/billpay/payment-confirmation"
              : "/path/payment/payment-confirmation",
            state: {
              completeResponse,
            }
          });

        } catch (err) {
          console.error("Error during payment process:", err);
          setLoading(false);
        }
      };


      script.onerror = () => {
        console.error("Failed to load CyberSource SDK script");
        setLoading(false);
        alert("Failed to load payment system. Please refresh and try again.");
      };

      document.head.appendChild(script);
    } catch (err) {
      console.error("Initialization error:", err);
      setConfigLoading(false);
      setLoading(false);
    }
  };


const handlePrePayment = async (clientReferenceCode) => {
    let array = [];
    localStorage.setItem("paymentType", paymentType);
    let billpayCheck = localStorage.getItem("billpay");
    let check = commonService.encodeString(JSON.stringify(landingResponse));
    if (billpayCheck === "true") {
      array.push({
        billId: connectionId,
        Amount: amount,
        accountId: landingResponse.accountDetails.accountId,
        userName: landingResponse.accountDetails.name,
        connectionId: landingResponse.accountDetails.connectionId,
      });
      localStorage.removeItem("Details");
      localStorage.removeItem("customerName");
      localStorage.removeItem("BillpayDetails");
      localStorage.removeItem("connectionId");
      localStorage.setItem("BillpayDetails", JSON.stringify(array));
      localStorage.setItem("email", landingResponse.accountDetails.email);
      localStorage.removeItem("billId");
      localStorage.setItem("billId", connectionId);
      localStorage.setItem("connectionId", check);
      localStorage.setItem("mobileNo", landingResponse.accountDetails.phone);
      localStorage.setItem("paymentProcess", "Y");
      try {
        const res = await usageService.prePaymentProcessingBill(
          connectionId,
          amount,
          paymentType,
          landingResponse.accountDetails.connectionId,
          clientReferenceCode
        );

        setPrePaymentRes(res);
        localStorage.removeItem("orderId");
        // localStorage.setItem("orderId", res.reference_number);
        localStorage.setItem("orderId", res.data.prePaymentProcessing?.transaction_uuid);
        localStorage.removeItem("paymentProcess");
      } catch (err) {
        localStorage.removeItem("paymentProcess");
        console.error("Pre-payment processing error:", err);
      }
      
    } else {
      array.push({
        ConnectionId: connectionId,
        Amount: amount,
      });
      localStorage.removeItem("BillpayDetails");
      localStorage.removeItem("billId");
      localStorage.removeItem("Details");
      localStorage.setItem("Details", JSON.stringify(array));
      localStorage.setItem("email", emailId);
      localStorage.removeItem("customerName");
      localStorage.setItem("customerName", landingResponse.customerName);
      localStorage.removeItem("connectionId");
      localStorage.setItem("connectionId", check);
      localStorage.setItem("mobileNo", mobileNo);
      localStorage.setItem("paymentProcess", "Y");
      try {
        const res = await usageService.prePaymentProcessing(
          connectionId,
          amount,
          paymentType,
          emailId,
          clientReferenceCode
        );
        setPrePaymentRes(res.data.prePaymentProcessing);
        localStorage.removeItem("paymentProcess");
        localStorage.removeItem("paymentProcess");
        localStorage.removeItem("paymentInfo");
        localStorage.removeItem("orderId");
        localStorage.setItem("orderId", res.data.prePaymentProcessing?.transaction_uuid);
      } catch (err) {
        localStorage.removeItem("paymentProcess");
        console.error("Pre-payment processing error:", err);
      }
    }
  };
  return (
    <div>
      <div style={{ position: "relative", display: "inline-block", marginLeft: "3px" }}>
        <div
          style={{
            width: "111px",
            height: "42px",
            overflow: "hidden",
            borderRadius: "4px",
            opacity: iframeReady ? 1 : 0,
            pointerEvents: (checkedA && iframeReady) ? "auto" : "none",
              filter: checkedA
              ? "hue-rotate(200deg) saturate(2) brightness(0.8)"
              : "grayscale(100%) opacity(0.5)",
          }}
        >
          <div
            id="buttonPaymentListContainer"
            style={{
              width: "134px",
              height: "158px",
              transform: "scale(0.87) translateY(1px)",
              transformOrigin: "top left",
            }}
          />
        </div>
        {!iframeReady && (
          <div style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "111px",
            height: "42px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#8d8d8d",
            borderRadius: "4px",
            zIndex: 3,
            pointerEvents: "none",
          }}>
            <span style={{
              display: "inline-block",
              width: "14px",
              height: "14px",
              border: "2px solid #bbb",
              borderTop: "2px solid #1976d2",
              borderRadius: "50%",
              animation: "spin 1s linear infinite",
              marginRight: "6px",
              flexShrink: 0,
            }} />
            <span style={{ fontSize: "11px", color: "#ffffff" }}>CREDIT CARD...</span>
            <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
          </div>
        )}

       {iframeReady && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "111px",
            height: "42px",
            zIndex: 2,
            pointerEvents: "none",
          }}
        >
        <Button
        variant="contained"
        size="small"
        color="secondary"
        className={accentButton}
        style={{
          width: "100%",
          height: "41px",          
          minWidth: "unset",
          padding: "0 8px",        
          lineHeight: "41px",     
          fontSize: "13px",
        }}
      >
        CREDIT CARD
      </Button>
        </div>
      )}
      </div>
    </div>
  );
}
